export default "__VITE_ASSET__idv9u0dB__"